import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSynchronizeArrowsSquare1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "synchronize-arrows-square-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,4H16.5a3,3,0,0,1,3,3v6.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,20.5H7.5a3,3,0,0,1-3-3v-6.75"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "15.75 9.997 19.5 13.747 23.25 9.997"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "8.25 14.497 4.5 10.747 0.75 14.497"
		})
	]
});
export default SvgSynchronizeArrowsSquare1;
